import { render } from "./MdmSettingsSection.vue?vue&type=template&id=12cb3282&scoped=true"
import script from "./MdmSettingsSection.vue?vue&type=script&lang=js"
export * from "./MdmSettingsSection.vue?vue&type=script&lang=js"

import "./MdmSettingsSection.vue?vue&type=style&index=0&id=12cb3282&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cb3282"]])

export default __exports__